import React from 'react';

const translate = trKey => window.VULOG_TRANSLATE(trKey);

export const EnableCameraProcess = ({ onClose, contentType }) => {
    return (
        <div className="modal" style={{ display: 'block' }} role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{translate('EnableCameraProcess_title')}</h5>
                        <button
                            onClick={onClose}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {contentType === 'EnableCameraOrUploadFile' ? (
                            <p>{translate('EnableCameraOrUploadFile_description')}</p>
                        ) : (
                            <p>{translate('EnableCameraProcess_description')}</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button onClick={onClose} type="button" className="btn btn-primary">
                            {translate('Close')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
